import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Status } from '@app/shared/enums/Status.enum';

@Pipe({
    name: "statusPipe",
    standalone: false
})
export class StatusPipe implements PipeTransform {
  public userStatus = Status;
  public statusList: any[] = [];

  constructor(public translate: TranslateService) {
  }

  transform(key: any): any {
    for (let item in this.userStatus) {
      if (this.userStatus[item] === key)
        return this.translate.instant('ENUMS.' + item);
    }
  }

  getList() {
    this.statusList = [];

    for (const [propertyKey, propertyValue] of Object.entries(Status)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.statusList.push({id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey)});
    }

    return this.statusList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(Status)) {
      if (propertyValue == Id) {
        return {id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey)};
      }
    }
    return null
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(Status)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null
  }
}
